goog.provide('el8.uiwidget.Hover');

goog.require('el8.util.base');

/**
 * This enables a UI element to snap out of place as the user scrolls,
 * hover over other UI elements, and then snap back into the place
 * when returned to its original location.
 *
 * See ChartFeed.js and reqact/main.js for two examples usages
 * (the chart search bar and the list of reqact tabs in practice home)
 * 
 * @deprecated this is just a less performant version of native CSS's `position: sticky`
 */
el8.uiwidget.Hover = function(spec) {

    // Note that we need to have EITHER holder OR container.
    this._holder = spec.holder || null;  // doubles as the "top" anchor
    this._container = spec.container || null;

    this._hoverSection = spec.hoverSection;
    this._scrollContainer = spec.scrollContainer || $(document);
    this._keepHolderHeight = (spec.keepHolderHeight === true); // defaults to false
    this._BUFFER = (spec.buffer !== undefined) ? spec.buffer : -2;

    this._isHovering = false;
    this._isFrozen = false;
};

el8.uiwidget.Hover.prototype.start = function() {
    var that = this;
    var unthrottledScrollFn = function() {
        var topOffset = that._container ? that._container.offset().top : that._holder.offset().top;
        var bottomOffset = that._container ? that._container.offset().top + that._container.outerHeight(true) : null;
        var isScrollBelowTop =
            (that._scrollContainer.offset().top >= topOffset + that._BUFFER);
        var isScrollAboveBottom = !bottomOffset ? true :
            (that._scrollContainer.offset().top <= bottomOffset - that._hoverSection.outerHeight(true));
        if (isScrollBelowTop && isScrollAboveBottom) {
            // Hover!
            that._hover();
        } else {
            // Put back inline
            that._unhover();
        }
    };
    this._scrollFn = _.throttle(unthrottledScrollFn, 100); //the scroll event is triggered a lot
    this._scrollContainer.on('scroll', this._scrollFn);
    if (this._holder) { this._holder.height(this._holder.height()); }
    this._scrollFn(); //run the function once right away to setup _hover or _unhover state
    return this;
};

el8.uiwidget.Hover.prototype.end = function(spec) {
    spec = spec || {};
    if (spec.hover === true) { this._hover(); }
    if (spec.hover === false) { this._unhover(); }
    this._scrollContainer.unbind('scroll', this._scrollFn);
};

el8.uiwidget.Hover.prototype.adjustPositioning = function() {
    if (this._isHovering) { this._hover(); }
    // if we're not already hovering, do nothing
};

el8.uiwidget.Hover.prototype._hover = function() {
    // Hover!
    if (this._keepHolderHeight) {
        this._holder.height(this._holder.children().outerHeight());
    }
     // if we don't specially check this but the scrollContainer is the window/document, the widget breaks
    var top = (this._isScrollContainerWindow()) ? 0 : this._scrollContainer.offset().top;
    this._hoverSection.outerWidth(
            this._container ? this._container.width() : this._holder.width() )
        .css('top', top)
        .removeClass('el8StaticWidget')
        .addClass('el8HoveringWidget');
    this._isHovering = true;
};

el8.uiwidget.Hover.prototype._unhover = function() {
    // Put back inline
    if (this._keepHolderHeight) {
        this._holder.height(this._holder.height());
    }
    this._hoverSection.outerWidth(
            this._container ? this._container.width() : this._holder.width() )
        .css('top', 0)
        .removeClass('el8HoveringWidget')
        .addClass('el8StaticWidget');
    this._isHovering = false;
};

el8.uiwidget.Hover.prototype.pauseHover = function() {
    if (this._isHovering) {
        this._unhover();
    }
};
el8.uiwidget.Hover.prototype.freeze = function() {
    this._isFrozen = true;
};
el8.uiwidget.Hover.prototype.unfreeze = function() {
    this._isFrozen = false;
};

el8.uiwidget.Hover.prototype._isScrollContainerWindow = function() {
    if (this._scrollContainer[0] === $(document)[0] ||
        this._scrollContainer[0] === $(window)[0]) {
            return true;
    }
    return false;
};
